<!--ukey收件人信息-->
<template>
  <div class="module">
    <h5 class="module-title">Ukey收件人信息</h5>
    <div class="module-tips">信息填写后请认真核对，以确保安全收到Ukey</div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="收件人姓名："
            prop="realName"
            :rules="rules.realName"
          >
            <el-input
              v-model="ruleForm.realName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="收件人联系电话："
            prop="mobile"
            :rules="rules.mobile"
            label-width="126px"
          >
            <el-input
              v-model="ruleForm.mobile"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="图形验证码："
            prop="imageCode"
            :rules="rules.imageCode"
            class="graphical-code"
          >
            <el-input
              v-model="ruleForm.imageCode"
              placeholder="请输入图形验证码"
            ></el-input>
            <div class="graphical-code-button">
              <img :src="graphicalSrc" alt="" />
              <el-button
                type="text"
                size="small"
                @click="getGraphicalVerficationCode"
                >换一张
              </el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="短信验证码："
            prop="smsCode"
            :rules="rules.smsCode"
            label-width="126px"
            class="message-code"
          >
            <el-input
              v-model="ruleForm.smsCode"
              placeholder="请输入短信验证码"
            ></el-input>
            <el-button
              type="text"
              size="small"
              :disabled="verfityCodeDisalbed"
              @click="getMessageVerficationCode"
              >{{ verfityCode }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="收件人公司："
            prop="receiverCompanyName"
            :rules="rules.receiverCompanyName"
          >
            <el-input
              v-model="ruleForm.receiverCompanyName"
              placeholder="请输入收件人公司"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <el-form-item
            label="收件人地址："
            prop="districtId"
            :rules="rules.districtId"
            class="address"
          >
            <el-select
              v-model="ruleForm.provinceId"
              placeholder="请选择省"
              @change="provinceChange"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-select
              v-model="ruleForm.cityId"
              placeholder="请选择市"
              @change="cityChange"
            >
              <el-option
                v-for="item in cityList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-select
              v-model="ruleForm.districtId"
              placeholder="请选择区/县/街道"
            >
              <el-option
                v-for="item in districtList"
                :key="item.areaId"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
            <el-input
              v-model="ruleForm.address"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { mobileReg } from '@/modules/projectA/utils/verification';

export default {
  name: 'UkeyRecipientInfo',
  components: {},
  mixins: [],
  data() {
    return {
      graphicalSrc: '@/assets/img/paymenAccount/placeholder.png',
      verfityCode: '获取验证码',
      verfityCodeDisalbed: false,
      waitTime: 60,
      provinceList: [],
      cityList: [],
      districtList: [],
      ruleForm: {
        address: '',
        applyId: null,
        city: '',
        cityId: null,
        district: '',
        districtId: null,
        // id: 0,
        imageCode: '',
        messageId: '',
        mobile: '',
        province: '',
        provinceId: null,
        realName: '',
        receiverCompanyName: '',
        smsCode: '',
        trackingNumber: '',
      },
      rules: {
        mobile: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!mobileReg.test(value)) {
                callback(new Error('请输入正确的手机号'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        realName: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' },
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
        ],
        receiverCompanyName: [
          { required: true, message: '请输入收件人公司', trigger: 'blur' },
        ],
        districtId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                !this.ruleForm.provinceId ||
                !this.ruleForm.cityId ||
                !this.ruleForm.districtId ||
                !this.ruleForm.address
              ) {
                callback(new Error('请输入收件人地址'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
    };
  },
  watch: {},
  created() {
    this.getQueryAreaByCountryCode();
    // 初始化图形验证码
    this.getGraphicalVerficationCode();
    this.initData();
  },
  methods: {
    async initData() {
      const res = await Api.getEpayAccountUkey();
      if (res.success) {
        Object.keys(this.ruleForm).forEach((key) => {
          this.ruleForm[key] = res?.data?.[key];
        });
      }
      if (this.ruleForm.provinceId) {
        this.getCityByAreaId(this.ruleForm.provinceId);
      }
      if (this.ruleForm.cityId) {
        this.getDistrictByCityId(this.ruleForm.cityId);
      }
    },
    // 获取图形验证码
    async getGraphicalVerficationCode() {
      const res = await Api.getEpaySettleAccountUkeyImageCode();
      if (res.code === '200') {
        this.graphicalSrc = res.data;
      }
    },
    // 获取短信验证码
    async getMessageVerficationCode() {
      // 1、需要校验图形验证码是否正确；2、需要验证手机号格式是否正确
      if (!this.ruleForm.imageCode) {
        this.$message.warning('请输入图形验证码');
        return;
      }
      if (!mobileReg.test(this.ruleForm.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const res = await Api.sendEpaySettleAccountUkeySMS({
        imageCode: this.ruleForm.imageCode,
        mobile: this.ruleForm.mobile,
      });
      if (res.code === '200') {
        this.ruleForm.messageId = res.data;
        this.messageCountdown();
      }
    },
    // 短信验证码倒计时
    messageCountdown() {
      if (this.waitTime === 0) {
        this.verfityCode = '获取验证码';
        this.waitTime = 60;
        this.verfityCodeDisalbed = false;
      } else {
        this.verfityCodeDisalbed = true;
        this.verfityCode = `${this.waitTime}s后重新发送`;
        this.waitTime--;
        setTimeout(() => {
          this.messageCountdown();
        }, 1000);
      }
    },
    // 省份改变
    provinceChange(val) {
      this.cityList = [];
      this.districtList = [];
      this.ruleForm.cityId = '';
      this.ruleForm.districtId = '';
      this.getCityByAreaId(val);
    },
    cityChange(val) {
      this.districtList = [];
      this.ruleForm.districtId = '';
      this.getDistrictByCityId(val);
    },
    // 查询省份
    getQueryAreaByCountryCode() {
      const params = {
        countryCode: 'CN',
      };
      Api.queryAreaByCountryCode(params).then((res) => {
        if (res.code === '200') {
          this.provinceList = res.data;
        }
      });
    },
    // 查询城市
    getCityByAreaId(provinceAreaId) {
      const params = {
        parentAreaId: provinceAreaId,
      };
      Api.getCityByAreaId(params).then((res) => {
        if (res.code === '200') {
          this.cityList = res.data;
        }
      });
    },
    // 获取区县信息
    getDistrictByCityId(cityAreaId) {
      const params = {
        parentAreaId: cityAreaId,
      };
      Api.getDistrictByCityId(params).then((res) => {
        if (res.code === '200') {
          this.districtList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
